import { SlimItemEntity } from 'libs/gb-front/item/data-access/src/lib/+state/items.models'

/**
 * Interface for the 'Categories' data
 */
export interface CategoriesEntity {
  items: string[]
  items_count: number
  items_preview: SlimItemEntity[]
  auction: string
  label: string
  label_slug: string
  order: number
  uuid: string
}

export interface CategoriesResponse {
  count: number
  next: string | null
  previous: string | null
  results: CategoriesEntity[]
}
